import { ref } from 'vue';
import http from './http'

export default function useProject() {
    const loading = ref(false);
    const data = ref();
    const list = ref();

    const projectList = ref([]);
    const clientList = ref([]);

    function getProjectList() {
        loading.value = true;
        http.request('get', '/api/app/project/readlist?lite=true').then((res) => {
            if (res?.Type == 200) {
                projectList.value = res.Data;
            }
        }).finally(() => {
            loading.value = false;
        });
    }
    function getClientList() {
        loading.value = true;
        http.request('get', '/api/app/client/readlist').then((res) => {
            if (res?.Type == 200) {
                clientList.value = res.Data;
            }
        }).finally(() => {
            loading.value = false;
        });
    }

    function read(id) {
        //console.log("read", id);
        loading.value = true;
        http.request('get', '/api/app/project/read', {id}).then((res) => {
            if (res?.Type == 200) {
                
                if (res.Data.Clients == null) {

                    if (!id && window.$core.data.SelectedClient) {
                        //preset client data
                        res.Data.Clients = [{
                            BusinessName: window.$core.data.SelectedClient.BusinessName,
                            FirstName: window.$core.data.SelectedClient.FirstName,
                            LastName: window.$core.data.SelectedClient.LastName,
                            SameAddress: true,
                            Address: window.$core.data.SelectedClient.Address,
                            City: window.$core.data.SelectedClient.City,
                            PostalCode: window.$core.data.SelectedClient.PostalCode,
                            Province: window.$core.data.SelectedClient.Province,
                            Unit: window.$core.data.SelectedClient.Unit,
                            Phone: window.$core.data.SelectedClient.Phone,
                            Fax: null,
                            Email: window.$core.data.SelectedClient.Email,
                            Id: window.$core.data.SelectedClient.Id
                        }];

                        res.Data.Address = window.$core.data.SelectedClient.Address;
                        res.Data.City = window.$core.data.SelectedClient.City;
                        res.Data.PostalCode = window.$core.data.SelectedClient.PostalCode;
                        res.Data.Province = window.$core.data.SelectedClient.Province;
                        res.Data.Unit = window.$core.data.SelectedClient.Unit;
                       
                    } else {
                        res.Data.Clients = [{
                            BusinessName: null,
                            FirstName: null,
                            LastName: null,
                            SameAddress: true,
                            Address: null,
                            City: null,
                            PostalCode: null,
                            Province: null,
                            Unit: null,
                            Phone: null,
                            Fax: null,
                            Email: null,
                        }];
                    }
                    
                }
                data.value = res.Data;
                console.log("read", data.value);
                //if (!data.value.Client.Name) {
                //    data.value.Client.Name = [{ FirstName: '', LastName: '' }];
               // }
               
            }
        }).finally(() => {
            loading.value = false;
        });
    }

    function readList() {
        loading.value = true;
        http.request('get', '/api/app/project/readlist').then((res) => {
            if (res?.Type == 200) {
                list.value = res.Data;
               
            }
        }).finally(() => {
            loading.value = false;
        });
    }

    function create(callback) {
         
        loading.value = true;
        http.request("post", '/api/app/project/create', data.value).then(res => {

            if (callback) {
                callback(res);
            }

             
        }).finally(() => {
            loading.value = false;
        });
    }
    function update(callback) {
        loading.value = true;
        http.request("put", '/api/app/project/update', data.value).then(res => {

            if (callback) {
                callback(res);
            }
 
        }).finally(() => {
            loading.value = false;
        });
    }
   
   

    return { loading, data, list, read, readList, create, update, projectList, clientList, getProjectList, getClientList };
}
